'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarDays, iconCalendarDaysTag } from '@ni/nimble-components/dist/esm/icons/calendar-days';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarDays };
export { iconCalendarDaysTag };
export const NimbleIconCalendarDays = wrap(IconCalendarDays);